import React, { Component } from "react"
import styles from "../../css/menu.module.css"
import Collapsible from "react-collapsible"

const getCategories = items => {
  let tempItems = items.map(item => {
    return item.category
  })
  let tempCategories = new Set(tempItems)
  let categories = Array.from(tempCategories)
  return categories
}

export default class Menu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.items,
      serviceItems: props.items,
      categories: getCategories(props.items),
    }
  }

  // componentDidMount(){
  //     let tempItems = [...this.state.items]
  //     let items = tempItems.filter((service) => service.category = category)
  //     this.setState(() => {
  //       return {sericeItems: items}
  //     })
  // }

  render() {
    return (
      <section className={styles.menu}>
        <div className={styles.center}>
          {this.state.categories.map((category, index) => {
            return (
              <Collapsible
                key={index}
                trigger={category}
                open={false}
                triggerTagName='p'
                triggerClassName="CustomTriggerCSS"
                triggerOpenedClassName="CustomTriggerCSS--open"
                triggerStyle={{fontSize:'22px'}}
              >
                {this.state.items
                  .filter(services => services.category === category)
                  .map(service => (
                    <div className={styles.serviceArea}>
                      <div className={styles.serviceLine}>
                        <p className={styles.serviceName}>
                          <strong>{service.name}</strong>
                        </p>
                        <p className={styles.pricing}>{service.price}</p>
                      </div>
                      <div className={styles.serviceDescription}>
                        <p>{service.description}</p>
                      </div>
                    </div>
                  ))}
              </Collapsible>
            )
          })}
        </div>
      </section>
    )
  }
}
